import { Button } from '@/components/ui/button';
import { X, AlertTriangle } from 'lucide-react';
import { useImpersonation } from '@/hooks/useImpersonation';
import { useLocation } from 'react-router-dom';

export const GlobalImpersonationBanner = () => {
  const { impersonation, stopImpersonation } = useImpersonation();
  const location = useLocation();

  const handleStopImpersonating = () => {
    stopImpersonation();
    // Redirect based on where impersonation was started from
    const isPartnerPage = location.pathname.startsWith('/partner');
    window.location.href = isPartnerPage ? '/admin/partners' : '/admin/users';
  };

  if (!impersonation) return null;

  // Don't show on admin pages (AdminLayout has its own banner with proper positioning)
  const isAdminPage = location.pathname.startsWith('/admin');
  if (isAdminPage) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-destructive text-destructive-foreground py-2 px-4">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <AlertTriangle className="h-5 w-5" />
          <span className="font-medium">
            You are impersonating {impersonation.userName} ({impersonation.userEmail})
          </span>
        </div>
        <Button 
          variant="outline" 
          size="sm" 
          onClick={handleStopImpersonating}
          className="bg-destructive-foreground text-destructive hover:bg-destructive-foreground/90"
        >
          <X className="h-4 w-4 mr-2" />
          Stop Impersonating
        </Button>
      </div>
    </div>
  );
};
